


import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './SignIn.css';
import Button from './Button';

function SignIn() {
  const navigate = useNavigate();
  
  // State for form inputs
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  // State for messages
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.body.style.background = 'linear-gradient(180deg, #930203 0%, #930203 50%, #ffffff 50%)';

    const rawUser = localStorage.getItem('user');
    if (rawUser) {
      navigate('/dashboard', { replace: true });
    }

    return () => { document.body.style.background = ''; };
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/login.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Important for sessions!
        body: JSON.stringify({
          email,
          password
        })
      });

      const data = await response.json();

      if (response.ok) {
        const baseUrl = apiUrl.replace('/api', '');
        const user = {
          ...data.user,
          profilePicture: data.user.profilePicture
            ? `${baseUrl}/${data.user.profilePicture}`
            : null
        };
        localStorage.setItem('user', JSON.stringify(user));
        if (data.rememberToken) {
          localStorage.setItem('rememberToken', data.rememberToken);
        }
        navigate('/dashboard');
      } else {
        // Show error message
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin-page" style={{
      background: 'linear-gradient(180deg, #930203 0%, #690202 100%)',
      minHeight: '100dvh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      position: 'fixed',
    }}>
      <div className="sec-break" style={{ height: '100px' }}></div>

      <form onSubmit={handleSubmit} className="signin-modal d-flex flex-column justify-content-between">
        
        <div className="signin-top d-flex flex-column gap-2">
          <Link to="/" className="back-btn w-25 mb-4">←</Link>
          <p className="signin-label mt-4">ACCOUNT VERIFICATION</p>
          <h2 className="signin-heading fw-semibold">Log In</h2>

          {/* Form inputs */}
          <Button 
            as="input" 
            type="email" 
            placeholder="Email" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button 
            as="input" 
            type="password" 
            placeholder="Password" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {/* Error message */}
          {error && (
            <div style={{ 
              color: '#930203', 
              fontSize: '14px', 
              backgroundColor: '#ffe6e6',
              padding: '10px',
              borderRadius: '5px',
              border: '1px solid #930203',
              marginTop: '10px',
              marginBottom: '10px'
            }}>
              {error}
            </div>
          )}
        </div>

        <div className="signin-bot mb-4">
          <Button variant="cta" type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Log In'}
          </Button>
        </div>

      </form>
    </div>
  );
}

export default SignIn;
